import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class TwoFADataService {
  private baseUrl = environment.backend_server_url_identity;

  constructor(private http: HttpClient) { }

  private getUserEmail(): string {
    const user = localStorage.getItem('currentUser');
    if (user) {
      const parsed = JSON.parse(user);
      return parsed?.username || '';
    }
    return '';
  }

  getUserDetails(): Observable<any> {
    const email = this.getUserEmail();
    return this.http.get(`${this.baseUrl}/${email}`);
  }

  getMfaPhone():Observable<any>{
    return this.http.get(`${this.baseUrl}/getMfaPhone`);
  }

  updateMfaPhone(mfaFactorId: string, oktaUserId: string, mfaPhone: string): Observable<any> {
    const payload = {
      factorId: mfaFactorId,
      userId: oktaUserId,
      phoneNumber: mfaPhone
    };
    return this.http.post(`${this.baseUrl}/updateMfaPhone`, payload);
  }
}
